import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse,
  IconButton,
  Typography,
  Box,
  Tooltip,
} from "@mui/material";
import {
  PeopleFill,
  JournalBookmarkFill,
  HouseFill,
  ChevronLeft,
  ChevronRight,
  FileEarmarkPlayFill,
  ChevronDown,
  ChevronUp,
  ClipboardCheckFill,
  FileTextFill,
  EnvelopeFill,
  TrashFill,
} from "react-bootstrap-icons";

const drawerWidth = 260;

const Sidebar = ({
  collapsed,
  mobileVisible,
  onMobileClose,
  setSidebarCollapsed,
}) => {
  const location = useLocation();
  const [openDropdown, setOpenDropdown] = useState("");

  const toggleDropdown = (module) => {
    setOpenDropdown((prev) => (prev === module ? "" : module));
  };

  /* ===== MENU STRUCTURE ===== */
  const menuStructure = [
    // {
    //   label: "Dashboard",
    //   path: "/dashboard",
    //   icon: <HouseFill />,
    // },

    /* USER MANAGEMENT */
    // {
    //   label: "User Management",
    //   icon: <PeopleFill />,
    //   module: "users",
    //   children: [
    //     {
    //       label: "Users",
    //       path: "/users",
    //       icon: <PeopleFill />,
    //     },
    //   ],
    // },

    /* PROJECT MANAGEMENT */
    // {
    //   label: "Project Management",
    //   icon: <JournalBookmarkFill />,
    //   module: "projects",
    //   children: [
    //     {
    //       label: "Bid Estimate Tasks",
    //       path: "/tasks",
    //       icon: <ClipboardCheckFill />,
    //     },
    //     {
    //       label: "Manage Projects",
    //       path: "/projects",
    //       icon: <JournalBookmarkFill />,
    //     },
    //     {
    //       label: "Manage Bids",
    //       path: "/bids",
    //       icon: <FileEarmarkPlayFill />,
    //     },

    //     // {
    //     //   label: "Cost",
    //     //   path: "/cost",
    //     //   icon: <ClipboardCheckFill />,
    //     // },

    //     {
    //       label: "Schedule Flow Charts",
    //       path: "/schedule-flow-charts",
    //       icon: <ClipboardCheckFill />,
    //     },

    //     {
    //       label: "Action Schedule",
    //       path: "/action-schedule",
    //       icon: <ClipboardCheckFill />,
    //     },
    //   ],
    // },
    // {
    //   label: "User Projects",
    //   icon: <ClipboardCheckFill />,
    //   module: "users-list",
    //   children: [
    //     {
    //       label: "Users List",
    //       path: "/users-list",
    //       icon: <PeopleFill />,
    //     },
    //   ],
    // },
    {
      label: "Help & Support",
      path: "/help-support",
      icon: <HouseFill />,
    },
    {
      label: "Static Content",
      path: "/static-content",
      icon: <FileTextFill />,
    },
    {
      label: "Contact Us",
      path: "/contact-us-messages",
      icon: <EnvelopeFill />,
    },
    {
      label: "Delete Requests",
      path: "/account-deletion-requests",
      icon: <TrashFill />,
    },
    /* Contractor MANAGEMENT ✅ */

    // {
    //   label: "Sub Contractor Management",
    //   icon: <ClipboardCheckFill />,
    //   module: "contractors",
    //   children: [
    //     {
    //       label: "Sub Contractors",
    //       path: "/contractors",
    //       icon: <ClipboardCheckFill />,
    //     },
    //   ],
    // },
    /* Vendor MANAGEMENT */
    // {
    //   label: "Vendor Management",
    //   icon: <FileEarmarkPlayFill />,
    //   module: "vendors",
    //   children: [
    //     {
    //       label: "Vendors",
    //       path: "/vendors",
    //       icon: <FileEarmarkPlayFill />,
    //     },
    //   ],
    // },
    // {
    //   label: "Contract Management",
    //   icon: <JournalBookmarkFill />,
    //   module: "form-contract",
    //   children: [

    //     {
    //       label: "Form Contract",
    //       path: "/form-contract",
    //       icon: <ClipboardCheckFill />,
    //     },
    //   ],
    // },
  ];

  /* ===== AUTO OPEN DROPDOWN ON ROUTE ===== */
  useEffect(() => {
    let found = false;

    menuStructure.forEach((item) => {
      if (
        item.children?.some((sub) => location.pathname.startsWith(sub.path))
      ) {
        setOpenDropdown(item.module);
        found = true;
      }
    });

    if (!found) setOpenDropdown("");
  }, [location.pathname]);

  return (
    <Drawer
      variant={mobileVisible ? "temporary" : "permanent"}
      open={mobileVisible || !collapsed}
      onClose={onMobileClose}
      sx={{
        "& .MuiDrawer-paper": {
          width: collapsed ? 80 : drawerWidth,
          background: "linear-gradient(135deg, #08635b, #004d48)",
          color: "white",
          borderRight: "none",
          transition: "width 0.3s ease",
        },
      }}
    >
      {/* ===== HEADER ===== */}
      <Box
        display="flex"
        alignItems="center"
        justifyContent={collapsed ? "center" : "space-between"}
        p={2}
        sx={{ borderBottom: "1px solid rgba(255,255,255,0.2)" }}
      >
        <Typography variant="h6" sx={{ fontWeight: "bold" }}>
          {collapsed ? "OB" : "Owner Builder"}
        </Typography>

        <IconButton
          onClick={() => setSidebarCollapsed(!collapsed)}
          sx={{ color: "white" }}
        >
          {collapsed ? <ChevronRight /> : <ChevronLeft />}
        </IconButton>
      </Box>

      {/* ===== MENU ===== */}
      <List sx={{ mt: 1 }}>
        {menuStructure.map((item) => {
          const isActive = item.path && location.pathname === item.path;

          return (
            <React.Fragment key={item.label}>
              {!item.children ? (
                <Tooltip title={collapsed ? item.label : ""} placement="right">
                  <ListItemButton
                    component={Link}
                    to={item.path}
                    sx={{
                      mx: 1,
                      my: 0.5,
                      borderRadius: 1,
                      backgroundColor: isActive
                        ? "rgba(255,255,255,0.2)"
                        : "transparent",
                      borderLeft: isActive
                        ? "4px solid #ffeb3b"
                        : "4px solid transparent",
                      "&:hover": {
                        backgroundColor: "rgba(255,255,255,0.3)",
                      },
                    }}
                  >
                    <ListItemIcon sx={{ color: "white", minWidth: 25 }}>
                      {item.icon}
                    </ListItemIcon>
                    {!collapsed && <ListItemText primary={item.label} />}
                  </ListItemButton>
                </Tooltip>
              ) : (
                <>
                  {/* DROPDOWN PARENT */}
                  <ListItemButton
                    onClick={() => toggleDropdown(item.module)}
                    sx={{
                      mx: 1,
                      my: 0.5,
                      borderRadius: 1,
                      "&:hover": {
                        backgroundColor: "rgba(255,255,255,0.3)",
                      },
                    }}
                  >
                    <ListItemIcon sx={{ color: "white", minWidth: 25 }}>
                      {item.icon}
                    </ListItemIcon>

                    {!collapsed && (
                      <>
                        <ListItemText primary={item.label} />
                        {openDropdown === item.module ? (
                          <ChevronUp />
                        ) : (
                          <ChevronDown />
                        )}
                      </>
                    )}
                  </ListItemButton>

                  {/* DROPDOWN CHILDREN */}
                  <Collapse
                    in={openDropdown === item.module && !collapsed}
                    timeout="auto"
                    unmountOnExit
                  >
                    <List component="div" disablePadding>
                      {item.children.map((sub) => {
                        const isSubActive = location.pathname === sub.path;

                        return (
                          <ListItemButton
                            key={sub.path}
                            component={Link}
                            to={sub.path}
                            sx={{
                              pl: 6,
                              py: 0.8,
                              backgroundColor: isSubActive
                                ? "rgba(255,255,255,0.25)"
                                : "transparent",
                              borderLeft: isSubActive
                                ? "4px solid #ffeb3b"
                                : "4px solid transparent",
                              "&:hover": {
                                backgroundColor: "rgba(255,255,255,0.35)",
                              },
                            }}
                          >
                            <ListItemIcon sx={{ color: "white", minWidth: 25 }}>
                              {sub.icon}
                            </ListItemIcon>
                            <ListItemText primary={sub.label} />
                          </ListItemButton>
                        );
                      })}
                    </List>
                  </Collapse>
                </>
              )}
            </React.Fragment>
          );
        })}
      </List>
    </Drawer>
  );
};

export default Sidebar;
